import { useMemo } from 'react';
import { SimpleBars } from '../../Common/Charts/SimpleBars';
import { useEpidemiologyChartsDataContext } from './hooks/useEpidemiologyChartsDataContext';

export const TopDiagnosis = () => {
    const { chartData } = useEpidemiologyChartsDataContext();

    const { subtitles, values } = useMemo(() => {
        const items = (chartData?.epidemiologyTopDiagnosis || [])
            .slice()
            .sort(
                (a, b) =>
                    Number(b?.total || 0) -
                    Number(a?.total || 0)
            )
            .slice(0, 10);

        return {
            subtitles: items.map(
                (item) => `${item?.cid} - ${item?.nome || 'Não informado'}`
            ),
            values: items.map(
                (item) => Number(item?.total || 0)
            )
        };
    }, [chartData]);

    return (
        <SimpleBars
            title="Diagnósticos Principais Mais Frequentes"
            horizontal={true}
            subtitles={subtitles}
            values={values}
            height={420}
            showDataLabels={true}
        />
    );
};